import { faCloudUpload, faSpinnerThird } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import theme from "css/theme/light"
import { t } from "i18next"
import { useMemo } from "react"
import { useDropzone } from "react-dropzone"

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "24px",
  backgroundColor: theme.palette.grey["light"],
  color: theme.palette.secondary["main"],
  outline: "none",
  transition: "background .24s ease-in-out",
  cursor: "pointer",
  borderRadius: "4px",
  textAlign: "center"
}

const activeStyle = {
  backgroundColor: "rgba(233,233,233, 1)"
}

const acceptStyle = {
  backgroundColor: "rgba(233,233,233, 1)"
}

const rejectStyle = {
  borderColor: theme.palette.error.main
}

const StyledBox = styled(Box)(({ theme }) => ({
  position: "relative",
  borderWidth: 2,
  borderColor: theme.palette.secondary.main,
  borderStyle: "dashed"
}))

const MultipleFilePicker = ({ setFiles, isLoading }) => {
  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    multiple: true,
    paramName: () => "files",
    onDrop: (acceptedFiles) => {
      setFiles(acceptedFiles)
    }
  })
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject, isDragAccept]
  )

  return (
    <>
      <StyledBox
        bgcolor={theme.palette.grey[100]}
        border={1}
        borderColor="secondary.main"
        borderRadius="12px">
        <Box spacing={3}>
          <Box {...getRootProps({ style })}>
            <input {...getInputProps()} />
            <FontAwesomeIcon spin={isLoading} icon={isLoading ? faSpinnerThird : faCloudUpload} size="3x" />
            <Typography marginTop={2}>
              {isLoading
                ? t(`global.file.loading`, "Uploading files")
                : t(`global.file.label`, "Drop or click here to select files")}
            </Typography>
          </Box>
        </Box>
      </StyledBox>
    </>
  )
}

export default MultipleFilePicker
